import React from "react";
import { Link } from "react-router-dom";
import { Placard, PlacardSection, PlacardType } from "./_.styled.js";
import { Button } from "discover.medical.react-component-library";
import { logPromoPlacardClicked } from "../../util/analytics.js";

const PromoPlacard = ({
  description,
  imgAlt,
  imgSrc,
  title,
  url,
  urlText,
  telemetryData,
}) => {
  const handlePlacardClick = () => {
    logPromoPlacardClicked({
      navigateFrom: telemetryData.navigateFrom,
      navigateTo: telemetryData.navigateTo,
    });
  };

  return (
    <Placard data-element="placard" paddingBottom="md">
      <PlacardSection
        backgroundColor="secondary"
        data-element="placard-title"
        padding="md"
      >
        <PlacardType
          color="white"
          data-element="placard-title-type"
          fontFamily="secondary"
          fontSize="lg"
        >
          {title}
        </PlacardType>
      </PlacardSection>
      <PlacardSection data-element="placard-image">
        <img src={imgSrc} alt={imgAlt} />
      </PlacardSection>
      <PlacardSection
        backgroundColor="gray300"
        data-element="placard-description"
        padding="md"
        paddingBottom="lg"
        textAlign="center"
      >
        <PlacardType
          color="gray800"
          data-element="placard-description-type"
          fontSize="sm"
          italic
          marginBottom="md"
          textAlign="left"
        >
          {description}
        </PlacardType>
        <Button
          data-element="placard-button"
          to={url}
          as={Link}
          onClick={handlePlacardClick}
        >
          {urlText}
        </Button>
      </PlacardSection>
    </Placard>
  );
};

export default PromoPlacard;
